export const SHIPPING_COUNTRIES_TEST_ID = 'shipping-countries';
